// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper___GYFN","col":"Table_col__1gRV0","fulfillmentStatus":"Table_fulfillmentStatus__1Js6v","emailCol":"Table_emailCol__1IOxI"};